var MemberList = require('memberlist');


var MemberOperList = MemberList.extend({
    modeCategory: 'OPER'
});


module.exports = MemberOperList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/memberoperlist.js
// module id = bN3V
// module chunks = 1